import { withTranslation } from 'react-i18next';
import CountrySelect from '@kopapro/components/commons/inputs/countrySelect/countrySelect';

export default withTranslation()(CountrySelect);
